module.exports = __webpack_public_path__ + "img/p5-1-1.9fa0ef9a.png";